import { memo, useContext } from "react";
import { when } from "util/support";
import { IbanXSBanksCountriesPivotContext } from "./IbanXSBanksCountriesPivotContext";

const IbanXSBanksCountriesPivotLabel = () => {
    const { isLoading, pivot } = useContext(IbanXSBanksCountriesPivotContext);

    if (isLoading) {
        return 'Loading...';
    }

    return when(
        pivot,
        'Update IbanXS Bank Countries Pivot',
        'Create IbanXS Bank Countries Pivot'
    );
};

export default memo(IbanXSBanksCountriesPivotLabel);
